/**
 * Single source of truth for the icon shown on a transaction row.
 *
 * Fallback order: subcategory icon → category icon → 'tag'.
 *
 * The subcategory wins because that's the most specific thing the user
 * picked — editing 植栽's icon must flow to every 日常>植栽 row. Before
 * this helper existed, every display site read only `category.icon`, so
 * subcategory icon edits never showed up anywhere (the original
 * "我改的 icon 其他頁面都不對" report). Mirrors `displayTxName`.
 *
 * Accepts a structural `{ icon? }` shape rather than full CategoryRow so
 * call sites with partial category projections (RecurringScreen) can use
 * it too. Empty-string icons (un-set sheet cells) fall through.
 */
export interface HasIcon {
  icon?: string;
}

export function displayTxIcon(
  category: HasIcon | null | undefined,
  subcategory: HasIcon | null | undefined,
): string {
  return subcategory?.icon || category?.icon || 'tag';
}
